var map = {
	"./Commands/Commands.tsx": [
		52850,
		8328,
		39,
		5939,
		9682,
		4285
	],
	"./Commands/internal/Action.tsx": [
		96553,
		8328,
		6553
	],
	"./Commands/internal/Dialog.tsx": [
		79682,
		8328,
		39,
		5939,
		9682,
		3261
	],
	"./Footer/Footer.tsx": [
		30248,
		8328,
		248
	],
	"./Footer/samples/basic.tsx": [
		67922,
		8328,
		7922
	],
	"./NavigationFooter/NavigationFooter.tsx": [
		77920,
		8328,
		7920
	],
	"./NavigationFooter/samples/basic.tsx": [
		16538,
		8328,
		39,
		715,
		5939,
		3689,
		4041,
		9682,
		5948,
		6240
	],
	"./Page/Page.tsx": [
		15948,
		8328,
		39,
		715,
		5939,
		3689,
		9682,
		5948,
		3942
	],
	"./Page/components.tsx": [
		18527,
		8328,
		8527
	],
	"./Page/internal/Section.tsx": [
		66941,
		8328,
		6941
	],
	"./Page/internal/Sidebar.tsx": [
		27219,
		8328,
		7219
	],
	"./Page/internal/SidebarItem.tsx": [
		10534,
		8328,
		534
	],
	"./Page/samples/basic.tsx": [
		96231,
		8328,
		39,
		715,
		5939,
		3689,
		4041,
		9682,
		5948,
		8302
	],
	"./Page/samples/layout.tsx": [
		95495,
		8328,
		39,
		715,
		5939,
		3689,
		4041,
		9682,
		5948,
		3398
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5961;
module.exports = webpackAsyncContext;